/**
 * Rack create/update payload helpers (#995 / #1052).
 */

import type { RackConfiguration } from '../types/rack';

/** Strip server metadata before POST /requests/:id/racks */
export function toCreateRackPayload(
  rack: RackConfiguration,
): Omit<RackConfiguration, 'id' | 'createdAt' | 'updatedAt'> {
  const { id: _id, createdAt: _createdAt, updatedAt: _updatedAt, ...payload } = rack;
  return payload;
}
